import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'name',
        title: i18n.t('customer.address.name'),
        rules: {required: true, min: 3 },
        modal: ['name'],
        data: ['name'],
        additionalButton: false,
        checkBox: false,
    },
    {
        type: 'select',
        name: 'country',
        nextField: 'city',
        title: i18n.t('general.country'),
        rules: {required: true},
        modal: ['country_id'],
        data: ['country'],
        options: {
            data: [],
            label: 'name',
            track: 'country_id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'city',
        nextField: 'district',
        beforeField: 'country',
        title: i18n.t('general.city'),
        rules: {required: true},
        modal: ['city_id'],
        data: ['city'],
        options: {
            data: [],
            label: 'name',
            track: 'city_id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'district',
        beforeField: 'city',
        title: i18n.t('general.district'),
        rules: {required: true},
        modal: ['town_id'],
        data: ['town'],
        options: {
            data: [],
            label: 'name',
            track: 'town_id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'text',
        name: 'pk',
        title: i18n.t('customer.wizzard.postCode'),
        rules: {required: false, min: 3},
        modal: ['pk'],
        data: ['pk'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'masked',
        name: 'fax_no',
        title: i18n.t('customer.address.faxNo'),
        rules: { regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ },
        options: false,
        mask:"\+\ 11 (111) 111 1111",
        modal: ['fax_no'],
        data: ['fax_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'taxNo',
        title: i18n.t('customer.address.taxNo'),
        rules: {},
        modal: ['tax_no'],
        data: ['tax_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'taxOffice',
        title: i18n.t('customer.address.taxOffice'),
        rules: {},
        modal: ['tax_office'],
        data: ['tax_office'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'address',
        title: i18n.t('customer.address.address'),
        rules: { required: true},
        modal: ['address'],
        data: ['address'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/addressForm.js